import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const NAV_LINKS = [{
  href: '#about',
  label: 'About'
}, {
  href: '#experience',
  label: 'Experience'
}, {
  href: '#skills',
  label: 'Skills'
}, {
  href: '#board',
  label: 'Board Readiness'
}, {
  href: '#impact',
  label: 'Impact'
}, {
  href: '#framework',
  label: 'Strategy'
}, {
  href: '#trackrecord',
  label: 'Track Record'
}, {
  href: '#technology',
  label: 'Technology'
}, {
  href: '#governance',
  label: 'Governance'
}, {
  href: '#contact',
  label: 'Contact'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${scrolled ? 'bg-navy/97 backdrop-blur-sm shadow-md shadow-navy-dark/20' : 'bg-navy'}`} data-id="element-142" data-mp="1kzq97bw2z1m6">
      <nav className="max-w-content mx-auto px-6 lg:px-10 h-[76px] flex items-center justify-between gap-6" data-id="element-143" data-mp="enapkr1ew4gl">
        <a href="#hero" className="flex items-center gap-3 shrink-0" aria-label="Stephanie Meyer, home" data-id="element-144" data-mp="jm450p09e5je">
          <span className="flex h-9 w-9 items-center justify-center border border-gold text-gold font-serif text-base" data-id="element-145" data-mp="om072ipebmwb">
            SM
          </span>
          <span className="hidden sm:block text-white font-serif text-base tracking-wide whitespace-nowrap" data-id="element-146" data-mp="3n19kdpcndjsi">
            Stephanie Meyer
          </span>
        </a>

        <div className="hidden xl:flex items-center gap-6 overflow-x-auto" data-id="element-147" data-mp="vdzesjb04mu">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="text-[11px] font-semibold uppercase tracking-wide text-slate-300 hover:text-gold transition-colors duration-200 whitespace-nowrap" data-id="element-148" data-mp="5o73rfav1aye">
              {link.label}
            </a>)}
        </div>

        <div className="hidden xl:block shrink-0" data-id="element-149" data-mp="3196t51blxmih">
          <a href="#contact" className="inline-flex items-center border border-gold px-5 py-2.5 text-xs font-semibold uppercase tracking-wide text-gold hover:bg-gold hover:text-navy transition-colors duration-200" data-id="element-150" data-mp="2wcygpvoso7f0">
            Board Inquiry
          </a>
        </div>

        <button type="button" onClick={() => setOpen(prev => !prev)} className="xl:hidden text-white p-2" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-151" data-mp="2idgot7g7ce1f">
          {open ? <XIcon className="h-6 w-6" data-id="element-152" data-mp="2s88nkelit6xs" /> : <MenuIcon className="h-6 w-6" data-id="element-153" data-mp="2naz2tc92tjga" />}
        </button>
      </nav>

      {open && <div className="xl:hidden bg-navy border-t border-white/10 px-6 py-6 grid grid-cols-2 gap-4 max-h-[70vh] overflow-y-auto" data-id="element-154" data-mp="7k44fuivba4j">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="text-xs font-semibold uppercase tracking-wide text-slate-200 hover:text-gold transition-colors duration-200" data-id="element-155" data-mp="2ndor8az6gjn">
              {link.label}
            </a>)}
          <a href="#contact" onClick={() => setOpen(false)} className="col-span-2 mt-2 inline-flex items-center justify-center border border-gold px-5 py-2.5 text-xs font-semibold uppercase tracking-wide text-gold hover:bg-gold hover:text-navy transition-colors duration-200" data-id="element-156" data-mp="55frj5t2rm3m">
            Board Inquiry
          </a>
        </div>}
    </header>;
}